module.exports = __webpack_public_path__ + "openmined.5132b21.png";